import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer } from 'utils/redux-injectors';
import { TargetExecutionState } from './types';
import { gameManagerActions } from 'app/components/GameManager/slice';
import {
  selectTargetExecution,
  selectTargetExecutionReport,
} from './selectors';

export const initialState: TargetExecutionState = {};

const slice = createSlice({
  name: 'targetExecution',
  initialState,
  extraReducers: builder =>
    builder
      .addCase(
        gameManagerActions.commit,
        (state, action: PayloadAction<any>) => {
          return initialState;
          // return state;
        },
      )
      .addCase(
        gameManagerActions.beginEditDelivery,
        (state, action: PayloadAction<any>) => {
          state.save = state.accuracy;
        },
      )
      .addCase(
        gameManagerActions.setEditDelivery,
        (
          state,
          action: PayloadAction<{
            targetExecution?: ReturnType<typeof selectTargetExecutionReport>;
          }>,
        ) => {
          state.accuracy = action.payload.targetExecution;
        },
      )
      .addCase(
        gameManagerActions.finishEditDelivery,
        (state, action: PayloadAction<any>) => {
          state.accuracy = state.save;
        },
      ),
  reducers: {
    setAccuracy(state, action: PayloadAction<{ accuracy: number }>) {
      state.accuracy = action.payload.accuracy;
    },
  },
});

export const { actions: targetExecutionActions } = slice;

export const useTargetExecutionSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useTargetExecutionSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
